module.exports = __webpack_public_path__ + "assets/img/btn-more-b027d202.png";